import type * as MapLibre from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

// maplibre resolves its worker by URL relative to its own module, which the
// production bundle relocates into a hashed chunk. Left alone the worker 404s
// into the SPA fallback and every map renders controls over a blank canvas
// with no error, so point it at the asset the bundler emits.
let mapLib: Promise<typeof MapLibre> | undefined;

export function loadMapLib() {
  mapLib ??= import('maplibre-gl').then((maplibre) => {
    maplibre.setWorkerUrl(workerUrl);
    return maplibre;
  });
  return mapLib;
}
